import { render, staticRenderFns } from "./edit-modal.vue?vue&type=template&id=61f0d438&scoped=true&lang=pug&"
import script from "./edit-modal.vue?vue&type=script&lang=ts&"
export * from "./edit-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f0d438",
  null
  
)

export default component.exports